module.exports = __webpack_public_path__ + "media/select1.caeaf6e0.mp3";